export enum SessionRequestType {
  UnlockSession = 'UnlockSession',
  LockSession = 'LockSession',
}

export interface SessionRequest {
  MsgMessageId: string;
  UpdateSessionRequest: {
    RequestHeader: {
      PegaID: string;
      RequestType: SessionRequestType;
      TransRefGUID: string;
      ReferenceID: string;
      RequestedBy: string;
    };
  };
}

export interface SessionResponse {
  StatusCd: string;
}
